import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/candidateProfile/main"));

const CandidateProfile = () => {
  return (
    <Layout pageHeading="Profile">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default CandidateProfile;
